import styled from "styled-components";

const Span = styled.span`
  display: block;
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 2px;
  font-weight: 800;

  @media (max-width: 767px) {
    font-size: 12px;
  }
 
`;
export default Span;
